import fetch from '../utils/fetch'

export function login (data) {
  return fetch({
    url: '/contract/comm/login/onLogin',
    method: 'post',
    data
  })
}

export function getReplaceCode () {
  return fetch({
    url: '/contract/comm/login/getCheckCode',
    method: 'get'
  })
}


export function modifyPassword (data) {
    return fetch({
        url: '/sram/archives/modifyPassword',
        method: 'get',
        params: data
    })
}


export function sramGetUser (data) {
    return fetch({
        url: '/sram/comm/login/getUser',
        method: 'get'

    })
}


export function getCheckCode (data) {
    return fetch({
        url: '/sram/archives/getCheckCode',
        method: 'get',
        params: data
    })
}


export function resetPass (data) {
    return fetch({
        url: '/sram/archives/resetPass',
        method: 'get',
        params: data
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js